import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { GroupBaseModel } from '@smarttask-common/src/lib/models/Group/Core/GroupBaseModel';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class GroupHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.group_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.group_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.group_create, (group_id: number) => {
            this.broadcast(SharedEventNameEnum.group_create, { group_id });
        });

        this.on(SharedEventNameEnum.group_base_update, (group_id: number, group_base: GroupBaseModel) => {
            this.broadcast(SharedEventNameEnum.group_base_update, { group_id, group: group_base });
        });

        this.on(SharedEventNameEnum.group_order_update, (group_id: number, order_index: number) => {
            this.broadcast(SharedEventNameEnum.group_order_update, { group_id, order_index });
        });

        this.on(SharedEventNameEnum.group_delete, (group_id: number) => {
            this.broadcast(SharedEventNameEnum.group_delete, { group_id });
        });
    };
}
